import React from 'react';
import { CartProvider } from './contexts/CartContext';
import { CartPopup } from './components/CartPopup';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { ListicleSection } from './components/ListicleSection';
import { ProductSection } from './components/ProductSection';
import { SocialProof } from './components/SocialProof';
import { DoctorSection } from './components/DoctorSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ScienceSection } from './components/ScienceSection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <CartProvider data-id="element-0">
      <div className="w-full min-h-screen bg-white" data-id="element-1">
        {/* Sticky Top Bar */}
        <TopBar data-id="element-2" />

        {/* Hero Section */}
        <HeroSection data-id="element-3" />

        {/* 5 Reason Listicle Sections */}
        <div className="w-full bg-white" data-id="element-4">
          <ListicleSection number={1} title="Reawakens Dormant Follicles" description="Most hair loss happens when follicles enter a prolonged resting phase. CrownControl's 650nm red light penetrates deep into the scalp, triggering cellular activity that reactivates dormant follicles and kickstarts the natural growth cycle." imagePosition="left" data-id="element-5" />
          <ListicleSection number={2} title="Improves Scalp Circulation" description="Healthy hair needs oxygen and nutrients. Red light therapy increases blood flow to the scalp by up to 54%, ensuring your follicles get everything they need to produce thick, strong hair. Better circulation means better growth." imagePosition="right" imageUrl="https://cdn.magicpatterns.com/uploads/wGkDM5fk7B9tBsprvfA9Ao/ChatGPT_Image_Feb_23,_2026,_12_39_53_PM.png" data-id="element-6" />
          <ListicleSection number={3} title="Drug-Free, Hormone-Free Solution" description="Unlike finasteride or minoxidil, CrownControl doesn't interfere with your hormones or cause unwanted side effects. It's a natural, non-invasive approach that works with your body's biology—not against it." imagePosition="left" imageUrl="https://cdn.magicpatterns.com/uploads/nXPHnosskQVvUhQNxFbTE5/ChatGPT_Image_Feb_23,_2026,_12_33_41_PM.png" data-id="element-7" />
          <ListicleSection number={4} title="Clinically Supported Red Light Wavelengths" description="The 650nm wavelength isn't random—it's FDA-cleared and backed by over 50 clinical studies. This specific frequency has been proven to stimulate hair growth at the cellular level, with results visible in as little as 3-4 months." imagePosition="right" imageUrl="https://cdn.magicpatterns.com/uploads/kMvdBLkjejsucfHrEgUfvg/hf_20260222_200221_409884e3-72fb-4f3f-9238-79e683e621ff.png" data-id="element-8" />
          <ListicleSection number={5} title="10 Minutes a Day, Total Privacy" description="No clinic visits. No embarrassing procedures. Just put on the hat, press start, and go about your day. The hands-free design and auto-timer make it effortless to fit into your routine—whether you're working, reading, or watching TV." imagePosition="left" imageUrl="https://cdn.magicpatterns.com/uploads/iDwoZdD1amQTpgsWTGWpQn/hf_20260222_211158_50ab9739-48f2-4d06-b182-5fd66e9dc975.png" data-id="element-9" />
        </div>

        {/* Product Section with FAQ */}
        <ProductSection data-id="element-10" />

        {/* Social Proof */}
        <SocialProof data-id="element-11" />

        {/* Doctor Recommendation */}
        <DoctorSection data-id="element-12" />

        {/* Risk-Free Guarantee */}
        <GuaranteeSection data-id="element-13" />

        {/* Science Section */}
        <ScienceSection data-id="element-14" />

        {/* Final CTA */}
        <FinalCTA data-id="element-15" />
      </div>

      {/* Cart Popup */}
      <CartPopup data-id="element-16" />
    </CartProvider>;
}